import WalletConnectProvider from "@walletconnect/web3-provider";
import { PolygonMainnet, PolygonTestnet } from "./NetworkDetails";
var INFURA_ID = "e5bff7bf9ac648f0bb8a4c8ba85264fb";
export var MetamaskProviderOptions = {
    injected: {
        display: {
            name: "MetaMask",
            description: "Connect with a MetaMask Wallet",
        },
        package: null,
    },
};
export var WalletConnectProviderOptions = {
    walletconnect: {
        package: WalletConnectProvider,
        options: {
            infuraId: INFURA_ID,
            rpc: {
                137: PolygonMainnet.rpcUrls[0],
                80001: PolygonTestnet.rpcUrls[0],
            },
        },
    },
};
export var TorusProviderOptions = {
    buildEnv: "production",
    enableLogging: true,
    showTorusButton: true,
    network: {
        host: "matic",
    },
    integrity: { check: false, version: "1.27.3" },
};
export var WEB3_CACHE_PROVIDER = "WEB3_CONNECT_CACHED_PROVIDER";
